import { render, staticRenderFns } from "./DownloadAppWeb.vue?vue&type=template&id=de56e418"
import script from "./DownloadAppWeb.vue?vue&type=script&lang=ts"
export * from "./DownloadAppWeb.vue?vue&type=script&lang=ts"
import style0 from "./DownloadAppWeb.vue?vue&type=style&index=0&id=de56e418&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports